<template>
  <div
    aria-label="Progress"
    :aria-valuemax="maxValue"
    :aria-valuenow="value"
    class="w-full"
    data-test-id="vf-meter"
    role="meter"
    style="height: max-content"
  >
    <span
      v-if="minLabel || maxLabel"
      class="text-xs pb-1 flex between c-grey-10 fw-bold"
    >
      <span>{{ minLabel }}</span>
      <span>{{ maxLabel }}</span>
    </span>
    <span class="flex relative between">
      <span class="b-b b-grey-50 w-full top-1/2 absolute" />
      <span
        v-for="key in maxValue"
        :key
        class="rounded-full z-1 i-block"
        :class="[key === value ? 'bg-grey-10 !bg-brand-2' : 'b b-grey-50 bg-white']"
        style="width: 0.625rem; height: 0.625rem"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
const {
  value = 3,
  maxValue = 5
}
  = defineProps<{
    /**
     * Defines current meter value
     */
    value?: number
    /**
     * Defines meter max value and determines number of steps rendered
     */
    maxValue?: number
    /**
     * Label for low end of meter
     */
    minLabel?: string
    /**
     * Label for high end of meter
     */
    maxLabel?: string
  }>()
</script>
